import React, { FunctionComponent } from 'react';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { meetingBoardsPageSelectors } from '../../../../../app/page/page-storage/meeting-boards/meeting-boards.selectors';
import { IBoardList } from '../../../../../app/resource/boards/boardList/boardList.types';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { Board } from '../BoardsWidget/Board';
import { Boards } from '../BoardsWidget/Boards';
import { WidgetWrapper } from '../WidgetWrapper';
import { IWidgetUnimplemented } from './types';
import { BoardListsWrapper } from '../BoardsWidget/Board/BoardListsWrapper';

function isValidUrl(url?: string) {
  if (!url) {
    return false;
  }
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
}

export const WidgetUnimplemented: FunctionComponent<IWidgetUnimplemented> = ({ agendaItem, meetingId }) => {
  const isFreeActivity = agendaItem.keyName === 'free_activity';
  const isBoard = agendaItem.keyName === 'accountability_board';
  const isBoardList = agendaItem.keyName === 'accountability_list';
  const isExternalURL = agendaItem.keyName === 'external_url';

  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);
  const userId = useSelect(authSelectors.selectLoggedUser);
  const meetingBoards = useSelect(meetingBoardsPageSelectors.selectMeetingBoards);
  const boardId = agendaItem.boardId && isBoard ? agendaItem.boardId : null;
  const boardListIds = boardId
    ? ((meetingBoards[meetingId].boardItems[Number(boardId)].boardListIds as unknown) as IBoardList['id'][])
    : [];
  const admin = meeting?.administratorIds.includes(userId ? userId : '');

  let externalURLBlock: React.ReactNode | null = null;
  if (isExternalURL) {
    if (agendaItem.embedUrl) {
      if (isValidUrl(agendaItem.embedUrl)) {
        externalURLBlock = <iframe title="external URL" src={agendaItem.embedUrl} width="100%" height="100%" />;
      } else {
        externalURLBlock = <div>The value &quot;{agendaItem.embedUrl}&quot; is not a valid URL</div>;
      }
    } else {
      externalURLBlock = <div>No URL has been configured</div>;
    }
  }

  return (
    <WidgetWrapper name={agendaItem.title}>
      <>
        {isFreeActivity && (
          <div>
            <p>{agendaItem.description}</p>
          </div>
        )}
        {isBoard && agendaItem.boardId && admin !== undefined && (
          <div className="row mb-25 mt-3" style={{ width: '100%' }}>
            <div className="col-12">
              <div className="panel vto-text">
                <div className="panel-header small-header no-border pb-0 mb-2">
                  <h2 className="bold mr-3">Boards</h2>
                </div>
                <Boards
                  boardIds={[agendaItem.boardId]}
                  isAdmin={admin}
                  meetingId={meetingId}
                  showCreateButton={false}
                  currentBoardId={(boardId) => {
                    return;
                  }}
                />
                <Board
                  boardId={agendaItem.boardId}
                  boardListIds={boardListIds}
                  meetingId={meetingId}
                  isAdmin={admin}
                  unextendableBoardList={true}
                />
              </div>
            </div>
          </div>
        )}
        {isBoardList && agendaItem.boardListId && agendaItem.boardId && admin !== undefined && (
          <BoardListsWrapper
            boardListIds={[agendaItem.boardListId]}
            boardId={agendaItem.boardId}
            meetingId={meetingId}
            unextendableBoard={true}
            isAdmin={admin}
          />
        )}

        {isExternalURL ? (agendaItem.embedUrl ? (isValidUrl(agendaItem.embedUrl) ? null : null) : null) : null}
        {externalURLBlock}
      </>
    </WidgetWrapper>
  );
};
